<div class="fixed w-full md:bg-neutral-50">
  <div class="mx-auto flex h-dvh max-w-[1440px] gap-4 overflow-y-hidden md:p-4">
    <app-sidenav class="hidden md:block"></app-sidenav>
    <div class="flex h-full flex-1 flex-col overflow-hidden">
      <app-header></app-header>
      <main class="max-h-full flex-1 overflow-hidden">
        <router-outlet></router-outlet>
      </main>
    </div>
    <app-bottom-bar class="absolute bottom-[-1px] left-0 w-full"></app-bottom-bar>
    <app-notification
      *ngIf="notificationVisible()"
      (close)="closeNotification()"></app-notification>
  </div>
</div>
